import { RemoteHandleActivitiesAnalyticalPerStudent } from 'data/usecases';
import { HandleActivitiesAnalyticalPerTaskUseCaseInterface } from 'domain/usecases';
import { makeApiUrlActivitiesAnalyticalPerTask } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeHandleActivitiesAnalyticalPerTask =
  (): HandleActivitiesAnalyticalPerTaskUseCaseInterface =>
    new RemoteHandleActivitiesAnalyticalPerStudent(
      makeApiUrlActivitiesAnalyticalPerTask(),
      makeAxiosHttpClient(),
    );
